/**
 * Whether the document title should be badged as an AI suggestion. Requires
 * both that enrichment actually renamed the document (`originalTitle` stashed)
 * and that the doc still needs review — otherwise reviewed docs would keep the
 * badge on every subsequent edit. Keying off `needsReview` alone would badge an
 * untouched original filename when intelligent renaming is off for the tenant.
 * A user edit (`isDirty`) clears the badge.
 */
export function isTitleAiSuggested(
  originalTitle: string | null | undefined,
  value: string | null,
  isDirty: boolean,
  needsReview: boolean
): boolean {
  return Boolean(originalTitle) && originalTitle !== value && !isDirty && needsReview;
}
